module.exports = {
  message: {
    login: "Login",
    Username: "Username",
    zh: "Chinese",
    en: "English",
    out_name: "WIN365",
    out_app_kind: "レジャー",
    first: "レジャー　第一名",
    k_score: "K件の評価",
    out_app_price: "無料",
    install: "インストール",
    install_free: "インストール",
    android_no_support: "アンドロイド対応しない",
    start_download: "ダウンロード中",
    down_fail: "ダウンロード失敗",
    try_again: "再ダウンロード",
    installing: "インストール",
    install_introduce: "フローチャート",
    appal_video_guild: "アプリインストールビデオ\n",
    over: "完成",
    open_in_itune: "ご指示通り、ITUNESで開いてインストールしてください。",
    out_age_limit: "",
    intro: "説明",
    out_intro:
      "WIN365は、世界で最も優れたゲームプロバイダーの1つです。フィリピンに本社を置き。合法的なPAGCORゲームライセンスを取得しています。スポーツエンターテインメントとエンターテインメント施設のブランドを運営しており、世界中に事業拠点があります。10年以上のゲーム業界での経験と2000人以上のプロフェッショナルサービススタッフを擁する当社グループは、競技スポーツにおける戦略的協力を積極的に推進し、あらゆるゲームを厳格に監視、およびスクリーニングして、公平性を確保しています。グループの全てのゲームと製品は、何度もテストおよびレビューを繰り返し、正確なオッズと決済を保証し、ユーザーに公正で高品質なゲーム体験を提供します。",
    score_and_post: "評価とレビュー",
    fullscore: "満点５点",
    new_fun: "新規機能",
    out_new_feature: "",
    info: "情報",
    out_distributor: "Win365",
    distributor: "販売元",
    size: "サイズ",
    kind: "カテゴリ",
    need_ios_compatible: "IOS 9.0及び9.0以上のバージョンに対応",
    compatible: "互換性",
    out_langs: "中国語,英語,日本語,ベトナム語,タイ語",
    lang: "言語",
    age_limit: "年齢制限",
    age: "年齢",
    out_copyright: "",
    copyright: "コピーライト",
    price: "コスト",
    policy_privay: "プライバシーポリシー",
    randomCode: "唯一標識",
    under18: "18歳以上",
    disclaimer: "免責事項",
    disclaimer_detail:
      "当サイトはデベロッパー向けのアプリダウンロードとインストール用です。アプリの内容及び運営関連の事項について、デベロッパーは責任を取りますが、当サイトと関係がありません。",
    step1: "第一スッテプ",
    click_coner: "右上隅をクリックする",
    button: "ボタン",
    step2: "第二スッテプ",
    open_IE: "safariで入力して開いてください！",
    click_copy: "リンクをコッピーするボタンをクッリクする",
    outof_limit:
      "今日のダウンロード回数は上限です、明日もう一回試してください！",
    back_detail: "デスクトップを戻ってください",
    desc: "プロファイル",
    desc_why_install: "プロファイルとは？",
    desc_reson:
      "プロファイルは、ユーザーの端末を記録するためにApple社から認定されたものですので、ご安心してご利用ください。 Appleのユーザーライブラリにデバイスを登録するためのプロファイルがインストールされています。 Apple APPのインストールアシスタントをインストールする必要があります。",
    desc_explain_title: "2、インストール作業が行き詰った時の解決方法は？",
    desc_explain_desc:
      "解決方法：デスクトップに戻る-上にスライド-設定ページをオフにする-再インストール。",
    desc_why_password:
      "3、プロファイルをインストールする際にパスワードを入力する必要があるのはなぜですか？",
    desc_psw_reson:
      " どのようなパスワードを入力すればいいですか？デバイスの所有者が操作していることを確認するためには、インストールする際に[ロック解除パスワード]を入力する必要があります。",
    desc_know: "了解",
    guild_title_1: "IOS16 で開発者モードを有効にする方法?",
    guild_title: "プロファイルとは?",
    guild: "フローチャート",
    guild_step1: "1.プロファイルを許可する",
    guild_step2: '2.右上隅の"インストール"をクリックする',
    guild_step3: "3.携帯のパスワードを入力する",
    guild_step4: "4.インストールをクリックする",
    error1: "インターネット異常です。カスタマーセンターにご連絡ください！\n",
    ageleft: "",
    ageright: "歳以上",
    versionleft: "IOS ",
    versionright: "及び以上のバージョンに対応",
    to_main_site: "Webログイン",
    release_time: "発売日",
    previous_version: "前のバージョン",
    version_info: "バージョン情報",
    ios16Tip1: "ios16以降の場合、最初に開発者モードを有効にしてください",
    ios16Tip2:
      "“設定 -> プライバシーとセキュリティ -> 開発者モード -> 有効にする”"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/jp.js